<app-page-shell [title]="'sidebar_procedures' | translate" [description]="'procedures_desc' | translate">

        <!-- Tab Navigation -->
    <div class="mb-8">
        <app-tabs
            [items]="tabs"
            [activeValue]="activeTab"
            (activeValueChange)="setActiveTab($event)">
        </app-tabs>
    </div>

    <!-- Tab Content -->
    <ng-container [ngSwitch]="activeTab">
            <app-clinic-procedures *ngSwitchCase="'clinic'"></app-clinic-procedures>
            <app-insurance-procedures *ngSwitchCase="'insurance'" [editEntityId]="editEntityId"></app-insurance-procedures>
        </ng-container>
</app-page-shell>